import TimeOffHolidays from './TimeOffHolidays';

export default TimeOffHolidays;
